import React from 'react';
import { Button, EmptyContent, Flex, Grid } from '@/components/ui';
import {
  IconCloudUpload,
  IconFiles,
  IconFolder,
  IconList,
} from '@tabler/icons-react';
import { Link } from 'react-router-dom';
import { ROUTES } from '@/config/routes';
import { UseUploadHandlersReturn } from '../types';

interface UploadEmptyStateProps {
  handlers: Pick<
    UseUploadHandlersReturn,
    | 'folderInputRef'
    | 'filesInputRef'
    | 'handleSelectFolder'
    | 'handleSelectFiles'
    | 'handleFolderChange'
    | 'handleFilesChange'
  >;
}

export const UploadEmptyState: React.FC<UploadEmptyStateProps> = ({
  handlers,
}) => {
  const {
    folderInputRef,
    filesInputRef,
    handleSelectFolder,
    handleSelectFiles,
    handleFolderChange,
    handleFilesChange,
  } = handlers;

  return (
    <EmptyContent
      style={{ alignSelf: 'center', minHeight: '400px' }}
      withIconBox
      icon={<IconCloudUpload style={{ color: 'var(--accent-main)' }} />}
      title="Add files to prepare for upload"
      description="Drag & drop files or folders here, or use the buttons below. This is just preparation — files are not uploaded yet."
    >
      <Flex
        direction="column"
        gap="3"
        align="center"
        justify="center"
        wrap="wrap"
      >
        <Grid columns="2" gap="3" align="center" justify="center" wrap="wrap">
          <Button
            fullWidth
            startIcon={<IconFolder />}
            variant="classic"
            color="primary"
            type="button"
            onClick={handleSelectFolder}
          >
            Select Folder
          </Button>

          <Button
            fullWidth
            startIcon={<IconFiles />}
            variant="classic"
            color="primary"
            type="button"
            onClick={handleSelectFiles}
          >
            Select Files
          </Button>
        </Grid>

        <Button
          startIcon={<IconList />}
          variant="surface"
          color="default"
          as={Link}
          to={ROUTES.fileImporterFiles}
        >
          View Uploaded Files
        </Button>
      </Flex>

      {/* Hidden file inputs */}
      <input
        ref={folderInputRef}
        type="file"
        style={{ display: 'none' }}
        multiple
        // @ts-expect-error webkitdirectory is non-standard but needed for folder upload
        webkitdirectory="true"
        onChange={handleFolderChange}
      />

      <input
        ref={filesInputRef}
        type="file"
        style={{ display: 'none' }}
        multiple
        onChange={handleFilesChange}
        className="file-upload-input"
      />
    </EmptyContent>
  );
};
